import { render } from "./ProductDetailM.vue?vue&type=template&id=2b946054&scoped=true"
import script from "./ProductDetailM.vue?vue&type=script&lang=js"
export * from "./ProductDetailM.vue?vue&type=script&lang=js"

import "./ProductDetailM.vue?vue&type=style&index=0&id=2b946054&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b946054"]])

export default __exports__